import React from 'react';
import { Link } from 'react-router-dom';

// project-imports
import { slugify, slugifyV2 } from '../../utils';

// third-party
import ScrollAnimation from 'react-animate-on-scroll';
import { useBlogContext } from '../../context/blog_context';
import Image from '../../common/footer/Images/Image';

const PostFour = ({ filteredBlogs }) => {

    return (
        <>
            <div className="col-lg-6">
                <div className="row g-5">
                    {
                        filteredBlogs.slice(0, 4).map((item) => (
                            <div className="col-lg-6 col-md-6 col-12" key={item.id}>
                                <ScrollAnimation
                                    animateIn="fadeInUp"
                                    animateOut="fadeInOut"
                                    animateOnce={true}
                                    className="edu-blog blog-type-4 radius-small"
                                >
                                    <div className="inner">
                                        <div className="thumbnail">
                                            <Link to={process.env.PUBLIC_URL + `/blog-details/${slugifyV2(item?.title)}`}>
                                                <Image src={item?.image} alt="featured" fill className='w-100 h-100' />
                                            </Link>
                                        </div>
                                        <div className="content">
                                            <h6 className="title">
                                                <Link to={process.env.PUBLIC_URL + `/blog-details/${slugifyV2(item?.title)}`}>{item.title}</Link>
                                            </h6>
                                            <ul className="blog-meta">
                                                <li className='meta-container'><i className="icon-calendar-2-line"></i><span>{item.blogDate}</span></li>
                                                <li className='meta-container'><i className="ri-eye-line"></i><span>{item.view}</span></li>
                                            </ul>
                                        </div>
                                    </div>
                                </ScrollAnimation>
                            </div>
                        ))
                    }
                </div>
            </div>
            <div className="col-lg-6">
                <div className="row g-5">
                    {
                        filteredBlogs.slice(4, 8).map((item) => (
                            <div className="col-lg-6 col-md-6 col-12" key={item.id}>
                                <ScrollAnimation
                                    animateIn="fadeInUp"
                                    animateOut="fadeInOut"
                                    animateOnce={true}
                                    className="edu-blog blog-type-4 radius-small"
                                >
                                    <div className="inner">
                                        <div className="thumbnail">
                                            <Link to={process.env.PUBLIC_URL + `/blog-details/${slugifyV2(item?.title)}`}>
                                                <Image src={item?.image} alt="featured" fill />
                                            </Link>
                                        </div>
                                        <div className="content">
                                            <h6 className="title">
                                                <Link to={process.env.PUBLIC_URL + `/blog-details/${slugifyV2(item?.title)}`}>{item.title}</Link>
                                            </h6>
                                            <ul className="blog-meta">
                                                <li className='meta-container'><i className="icon-calendar-2-line"></i><span>{item.blogDate}</span></li>
                                                <li className='meta-container'><i className="ri-eye-line"></i><span>{item.view}</span></li>
                                            </ul>
                                        </div>
                                    </div>
                                </ScrollAnimation>
                            </div>
                        ))
                    }
                </div>
            </div>
        </>
    )
}

export default PostFour;